import React, { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/kidh/Header";
import Hero from "@/components/kidh/Hero";
import Philosophy from "@/components/kidh/Philosophy";
import Vision2035 from "@/components/kidh/Vision2035";
import Ecosystem from "@/components/kidh/Ecosystem";
import PolesMap from "@/components/kidh/PolesMap";
import Flagship from "@/components/kidh/Flagship";
import Configurator from "@/components/kidh/Configurator";
import Synergies from "@/components/kidh/Synergies";
import ContactForm from "@/components/kidh/ContactForm";
import Footer from "@/components/kidh/Footer";

function App() {
  // Reveal-on-scroll observer for .reveal elements
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App min-h-screen bg-[#FAFAF8] text-[#2D3436]">
      <Header />
      <main>
        <Hero />
        <Philosophy />
        <Vision2035 />
        <Ecosystem />
        <PolesMap />
        <Flagship />
        <Configurator />
        <Synergies />
        <ContactForm />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
